<template>
    <div :class="{'MoldEntry': true, 'FinishedThisMonth': MoldData.FinishedThisMonth, 'FinishedNextMonth': MoldData.FinishedNextMonth, 'PayingFromNextMonth': MoldData.PayingFromNextMonth}">
        <div class="Name" :title="MoldData.name">{{ MoldData.name }}</div>
        <div class="Factory">{{ MoldData.factory }}</div>
        <div class="Date">{{ FormatDate(MoldData.import_at) }}</div>
        <div class="Date">{{ FormatDate(MoldData.payment_at) }}</div>
        <div class="Price" :title="PaymentPerMonth()">{{ this.$FormatCurrency(MoldData.moldCostUSD, '$') }}</div>
        <div class="PaymentProgress" :title="PaymentProgressTitle()">{{ PaymentProgress() }}</div>
        <div style="flex: 0.5;">
            <div :class="['PaymentStatus', MoldData.payment_status]" :title="GetPaymentStatusJP()"></div>
        </div>
    </div>
</template>

<script>
export default{
    props:{
        MoldData: Object
    },
    methods:{
        GetPaymentStatusJP()
        {
            switch (this.MoldData.payment_status) {
                case 'pending': return '未処理';
                case 'in_progress': return '進行中';
                case 'cancelled': return `キャンセル済み (${this.FormData(this.MoldData.cancelled_at)})`;
                case 'paid': return '支払い済み';
                default: return this.MoldData.payment_status; // Fallback for unexpected cases
            }
        },
        FormatDate(date)
        {
            if (!date) return ''; // Handle null or undefined dates

            return new Intl.DateTimeFormat('ja-JP', { year: 'numeric', month: 'long' }).format(new Date(date));
        },
        PaymentPerMonth()
        {
            return `${this.$FormatCurrency(this.MoldData.moldCostUSD / 12 * this.MoldData.conversionRate)}/月`;
        },
        PaymentProgress()
        {
            return `${this.MoldData.paymentCount}/12`;
        },
        PaymentProgressTitle()
        {
            return `${this.$FormatCurrency(this.MoldData.moldCostUSD / 12 * this.MoldData.conversionRate * this.MoldData.paymentCount)}/${this.$FormatCurrency(this.MoldData.moldCostUSD * this.MoldData.conversionRate)}`
        }
    }
}
</script>

<style>
.MoldEntry
{
    display: flex;
    border: 1px solid black;
    border-radius: 10px;
    padding: 8px 10px;

    div{
        display: grid;
        place-content: center;
    }

    .Name
    {
        flex: 1;
        display: inline-block;
        font-weight: bold;
        max-width: 300px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: left;
    }

    .Factory
    {
        flex: 0.5;
        color: black;
        padding: 3px 8px;
    }

    .Date
    {
        flex: 0.5;
    }

    .Price
    {
        flex: 0.5;
        /* width: 120px; */
    }

    .PaymentProgress
    {
        flex: 0.5;
    }

    .PaymentStatus
    {
        /* margin-left: 10px; */
        border-radius: 50%;
        width: 22px;
        height: 22px;
    }

    .pending
    {
        background-color: gray;
    }

    .cancelled
    {
        background-color: gray;
    }

    .in_progress
    {
        background-color: rgb(236, 198, 9);
    }

    .paid
    {
        background-color: rgb(27, 182, 27);
    }
}

.PayingFromNextMonth
{
    background-color: rgb(253, 217, 217);
}

.FinishedThisMonth
{
    background-color: rgb(191, 242, 191);
}

.FinishedNextMonth
{
    background-color: rgb(255, 255, 171);
}
</style>